/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Suspense } from 'react';
import Lottie from 'react-lottie';

function DisplayLottie({ animationData }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
  };
  return (
    <Suspense fallback={<h1>...Loading</h1>}>
      {/* To override default onClick pause by Lottie */}
      <div onClick={() => null}>
        <Lottie options={defaultOptions} />
      </div>
    </Suspense>
  );
}

export default DisplayLottie;
